<script setup lang="ts">
import { useDark } from '@vueuse/core';
import LogoDark from '../assets/images/vismo-dark.svg';
import Logo from '../assets/images/vismo.svg';

const runtimeConfig = useRuntimeConfig();

const isDarkMode = useDark();

const logo = computed(() => (unref(isDarkMode) ? LogoDark : Logo));
</script>

<template>
  <footer class="footer">
    <div class="footer__owner">
      <NuxtLink to="/"><img :src="logo" class="footer__image" alt="Vismo Logo" /></NuxtLink>
      <p>© Vismo Labs Ltd {{ new Date().getFullYear() }}. All rights reserved.</p>
    </div>

    <ul class="footer__links">
      <li><h5>Company</h5></li>
      <li><NuxtLink to="/products">Products</NuxtLink></li>
      <li><NuxtLink to="/solutions">Solutions</NuxtLink></li>
      <li><NuxtLink to="/solutions">Pricing</NuxtLink></li>
    </ul>

    <ul class="footer__links">
      <li><h5>Resources</h5></li>
      <li><NuxtLink :to="runtimeConfig.public.helpUrl" target="_blank" external>Help</NuxtLink></li>
      <li>
        <NuxtLink :to="runtimeConfig.public.announcementsUrl" target="_blank" external>
          Announcements
        </NuxtLink>
      </li>
      <li><NuxtLink to="/blog">Blog</NuxtLink></li>
      <li><NuxtLink :to="`mailto:${runtimeConfig.public.emailInfo}`">Contact</NuxtLink></li>
    </ul>

    <ul class="footer__links">
      <li><h5>Legal</h5></li>
      <li><NuxtLink to="/terms-of-use">Terms of Use</NuxtLink></li>
      <li><NuxtLink to="/privacy-policy">Privacy Policy</NuxtLink></li>
      <li><NuxtLink to="/cookie-policy">Cookie Policy</NuxtLink></li>
    </ul>
  </footer>
</template>

<style scoped lang="scss">
@use '../assets/styles/_globals.scss' as g;

.footer {
  padding: 3rem 6rem 6rem;
  margin: 0 5rem;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8rem;

  @media (max-width: g.$desktop-breakpoint) {
    padding: 2rem 4rem 4rem;
    margin: 0 2rem;
    gap: 4rem;
  }

  @media (max-width: g.$mobile-breakpoint) {
    padding: 1rem 2rem 2rem;
    margin: 0;
  }

  &__owner {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  &__image {
    width: 5rem;
  }

  &__links {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    h5 {
      font-size: 1.1rem;
      font-weight: 500;
    }
  }
}
</style>
